// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "Dialog-Hn2Li";
var _5 = "title-1ACAd";
var _6 = "text-2LFq2";
var _7 = "actions-1edzi";
var _8 = "closeButton-1JyNs";
var _9 = "disabled-1RDmi";
var _a = "close__slide__button-_qfYp";
var _b = "content-1GibZ";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "Dialog", _5 as "title", _6 as "text", _7 as "actions", _8 as "closeButton", _9 as "disabled", _a as "close__slide__button", _b as "content" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "Dialog": _4, "title": _5, "text": _6, "actions": _7, "closeButton": _8, "disabled": _9, "close__slide__button": _a, "content": _b }
